import React, { useState, useEffect } from 'react'
import { useSnackbar } from 'notistack';
import { getYears, initPrjGoalData, monthPercent } from '../../utils/constCodeUtils';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setUserConfig, unloadUserConfig, viewUserConfig } from '../../modules/staticsModule/userConfig';
import * as yup from 'yup';
import { useFormik } from 'formik';
import _ from 'lodash';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';


import * as staticsApi from '../../lib/api/statics';
import YearGoalForm from '../../components/goalsetting/YearGoalForm';
import UserGoalTable from '../../components/goalsetting/UserGoalTable';

const UserGoalListContainer = ({ user }) => {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [years, setYears] = useState(null);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    // const [userGoalsData, setUserGoalsData] = useState(null);
    const [userGoalsData, setUserGoalsData] = useState(initPrjGoalData()); 
    const [totals, setTotals] = useState({ ptargetSales: 0, ptargetSalesProfit: 0 });

    const handleChangeYear = (event) => {
        setSelectedYear(event.target.value)
    }

    useEffect(() => {
        const arrYears = getYears(3, 1);
        setYears(arrYears);
    }, []);

    const { userConfig, error, loading } = useSelector(
        ({ staticsModule, loading }) => ({
            userConfig: staticsModule.userConfig.userConfig,
            error: staticsModule.userConfig.error,
            loading: loading['statics/VIEW_USER_CONFIG']
        }),
    );

    useEffect(() => {
        if (user && selectedYear) {
            let searchData = {
                "statYear": selectedYear,
                "usrUuid": user?.usrUuid,
            }
            dispatch(viewUserConfig(searchData))
        }

        return () => {
            dispatch(unloadUserConfig());
        }
    }, [user, selectedYear, dispatch]);

    useEffect(() => {
        if (Array.isArray(userConfig) && userConfig.length > 0) {
            setUserGoalsData(userConfig);

            const ptargetSales = _.sumBy(userConfig, 'ptargetSales');
            const ptargetSalesProfit = _.sumBy(userConfig, 'ptargetSalesProfit');

            setTotals((prevState) => ({
                ...prevState,
                ptargetSales, ptargetSalesProfit
            }));


        } else {

            setUserGoalsData(initPrjGoalData());
        }
    }, [userConfig]);

    let initialValues = {
        ptargetSales:
            userConfig && totals.ptargetSales !== null && totals.ptargetSales !== undefined
                ? totals.ptargetSales
                : '0',
        ptargetSalesProfit:
            userConfig && totals.ptargetSalesProfit !== null && totals.ptargetSalesProfit !== undefined
                ? totals.ptargetSalesProfit
                : '0',
    }
    let validationSchema = yup.object({
        ptargetSales: yup.number('숫자만 가능합니다').required('총 목표매출을 입력하세요').positive('양수만 입력가능합니다'),
        ptargetSalesProfit: yup.number('숫자만 가능합니다').required('총 목표매출 이익을 입력하세요').positive('양수만 입력가능합니다'),
    });
    const onSubmitHandler = (values, { setSubmitting }) => {
        const submit = async () => {
            onSave()

        };
        submit();
    };


    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: onSubmitHandler,
    });


    const onSave = async () => {
        // const months = calcurateData(formik.values.ptargetSales, formik.values.ptargetSalesProfit);
        let dataToSubmit = {
            usrUuid: user.usrUuid,
            year: selectedYear,
            monthGoals: userGoalsData
        }

        try {
            const res = await staticsApi.addStaticsConf(dataToSubmit);
            if (res.data.list) {
                dispatch(setUserConfig(res.data));
                enqueueSnackbar("목표 설정이 저장되었습니다", {
                    variant: 'success',
                });
                formik.setSubmitting(false);
            }
        } catch (err) {
            let message =
                typeof err.response !== 'undefined'
                    ? err.response.data.message
                    : err.message;
            enqueueSnackbar(message, {
                variant: 'error',
            });
        }

    }

    const calcurateData = (totalSales, totalProfit) => {
        let months = [];
        for (let index = 0; index < 12; index++) {
            let ptargetSales = totalSales * (monthPercent[index] / 100);
            let ptargetSalesProfit = totalProfit * (monthPercent[index] / 100);
            let newObject = { month: index + 1, ptargetSales: ptargetSales, ptargetSalesProfit: ptargetSalesProfit };
            months.push(newObject);
        }
        return months;
    }


    const onAutoDisHandler = (totalSales, totalProfit) => {
        const months = calcurateData(formik.values.ptargetSales, formik.values.ptargetSalesProfit);
        setUserGoalsData(months);
    }

    if (loading) {
        return (
            <Box
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <CircularProgress />
            </Box>
        )
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', px: 1, alignItems: 'center' }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <Box sx={{ mr: 1, minWidth: 120 }}>
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="selected-year-label">기준년도</InputLabel>
                            <Select
                                labelId="selected-year-label"
                                id="selected-year"
                                value={selectedYear}
                                label="년도"
                                onChange={handleChangeYear}
                            >
                                {years && years.map((item, index) => (
                                    <MenuItem key={index} value={item}>{item}</MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                    </Box>

                </Box>
                {(!Array.isArray(userConfig) || userConfig.length === 0) && (
                    <Box sx={{ px: 1 }}>
                        <Typography variant="body2" component="div">해당 사원의 {selectedYear} 년도 설정된 목표값이 없습니다.</Typography>
                    </Box>
                )}
            </Box>
            <Divider sx={{ my: 1 }} />
            <YearGoalForm formik={formik}  onAutoDisHandler={onAutoDisHandler} />
            {/* <UserGoalTable formik={formik} monthGoals={userGoalsData}  onAutoDisHandler={onAutoDisHandler} /> */}
            <UserGoalTable 
                    monthGoals={userGoalsData}
                   // 편집된 goals 을 부모 상태에 반영
                   onChangeGoals={updated => setUserGoalsData(updated)}
                   // 자동 분배도 부모 상태에 바로 반영
                   onAutoDisHandler={(sales, profit) => {
                     const months = calcurateData(sales, profit);
                     setUserGoalsData(months);
                   }}
            />
        </Box>
    )
}

export default UserGoalListContainer